import React, {Component} from "react";
import styled from 'styled-components/macro'
import PropTypes from "prop-types";
import {SocialArea} from "../Articles/components/SocialShare/SocialArea";
import logoImage from '../../assets/images/home-logo.svg'
import {SingleArticleHelmet} from "../Articles/components/SocialShare/Helmets";

const ArticleRow = styled.div.attrs({
    className: "row center-lg",
})`
    padding-bottom: 2rem;
`;

const ArticleMainRow = styled(ArticleRow)`
`;

const ArticleMainColumn = styled.div.attrs({
    className: "col-lg-10 col-xs-12",
})`
    background-color: #ffffff;
`;


const PreviewTextColumn = styled.div.attrs({
    className: "col-lg-10 col-xs-12"
})`
`;

const HeaderRow = styled(ArticleRow)`
    padding-top: 1rem;
`;

const HeaderColumn = styled.div.attrs({
    className: "col-xs-10"
})`
    padding-bottom: 0.4rem;
    padding-top: 0.5rem;
    
`;

const SummaryRow = styled.div.attrs({
    className: "row center-lg"
})`
    font-family: ${props => props.theme.largeTextFamily};
    text-align: justify;
    padding-top: 0.5rem;
`;

const SummaryColumn = styled.div.attrs({
    className: "col-lg-12 col-md-12 col-xs-12"
})`
    font-family:  ${props => props.theme.longTextFamily};
`;

const SocialRow = styled(ArticleRow)`
    padding-top:1rem;
`;

const SocialColumn = styled.div.attrs({
    className: "col-lg-12 col-md-12 col-xs-12"
})`
`;

const ImageRow = styled.div.attrs({
    className: "row center-xs",
})`
    padding-bottom: 1rem;
`;

const ImageColumn = styled.div.attrs({
    className: "col-xs-12"
})``;

const ArticleHeaderText = styled.h1`
    font-family:  ${props => props.theme.highlightFontFamily};
    font-size: 2.5rem;
    line-height: normal;
    font-weight: inherit;
`;

class SingleArticlePage extends Component {
    render() {
        let image = this.props.image;

        const header = this.props.header;
        const authorName = this.props.authorName;
        const relativePath = this.props.relativePath;
        const tags = this.props.tags;
        const imageAlt = this.props.header;
        const shortSummary = this.props.shortSummary;
        const socialArea = (<SocialArea title={header} tags={tags} shortSummary={shortSummary}/>);
        const summary = this.props.summary;
        const date = this.props.date;
        const readTime = this.props.readTime;
        const Content = this.props.content;

        let imageRow;

        if (image) {
            const imageClassname = this.props.className + "webfeedsFeaturedVisual";
                imageRow = (
                <ImageRow>
                    <ImageColumn>
                        <img src={image} alt={imageAlt} className={imageClassname}/>
                    </ImageColumn>
                </ImageRow>
            )
        }

        return (
            <ArticleMainColumn>
                <SingleArticleHelmet
                    imageAlt={imageAlt}
                    shortSummary={shortSummary}
                    author={authorName}
                    image={image}
                    relativePath={relativePath}
                    header={header}
                    summary={summary}
                    date={date}
                    readTime={readTime}
                    tags={tags}
                />
                <ArticleMainRow>
                    <PreviewTextColumn>
                        <HeaderRow>
                            <HeaderColumn>
                                <ArticleHeaderText>
                                    {header}
                                </ArticleHeaderText>
                            </HeaderColumn>
                        </HeaderRow>
                        {imageRow}
                        <SocialRow>
                            <SocialColumn>
                                {socialArea}
                            </SocialColumn>
                        </SocialRow>
                        <SummaryRow>
                            <SummaryColumn>
                                <Content/>
                            </SummaryColumn>
                        </SummaryRow>
                        <SocialRow>
                            <SocialColumn>
                                {socialArea}
                            </SocialColumn>
                        </SocialRow>
                    </PreviewTextColumn>
                </ArticleMainRow>
            </ArticleMainColumn>
        )
    }
}

SingleArticlePage.defaultProps = {
    image: logoImage,
    tags: ["envimate"]
};

SingleArticlePage.propTypes = {
    header: PropTypes.string.isRequired,
    tags: PropTypes.array,
    image: PropTypes.node,
    authorName: PropTypes.string.isRequired,
    readTime: PropTypes.number.isRequired,
    date: PropTypes.string.isRequired,
    relativePath: PropTypes.string.isRequired,

};

export {SingleArticlePage};
